module.exports = __webpack_public_path__ + "static/media/logo_500x200.369ebb95.png";